import { render } from 'preact';
import { App } from './app.js';

const root = document.getElementById('app');
if (!root) throw new Error('#app root element missing');
render(<App />, root);
